/**
* @Component Name: AccountInfoComponent
* @Module: Home
* @Module Functionality : To display the customer account information
* @Creation Date: August 12,2017
* @Author: sbaireddy
* @Version: 1.0
*/
import { Component, Input, OnInit } from '@angular/core';

import { Customer } from '../../shared/modal/customer';
import * as Constants from '../../shared/constants';

import { SharedService } from '../../shared/shared.service';
import { CustomerService } from '../../services/customer.service';

@Component({
    selector: 'account-info-cmp',
   // moduleId: module.id,
    templateUrl: 'account-info.component.html',
    styleUrls: ['account-info.component.css']
})

export class AccountInfoComponent implements OnInit {
    private COMPONENT_NAME: string = 'AccountInfoComponent';
    @Input() customer: Customer;
    storeId: number;
    rtStoreId: number = Constants.STORE_ID_RT;

    constructor(
        public sharedService: SharedService,
        public customerService: CustomerService) {
    }

     /**
    * This function is used to initialize the directive/component after Angular
    * first displays the data-bound properties.It is invoked only once when the
    * directive is instantiated.It is invoked only once when the
    * directive is instantiated.Here it is initializing the cart & customer informations
    * @return {void}
    */
    ngOnInit(): void {
        const METHOD_NAME: string = 'ngOnInit()';
        console.log('AccountInfoComponent.ngOnInit()>>Start.');
        this.sharedService.storeId.subscribe((val: number) => { this.storeId = val; });
    }

     /**
     * Cleanup just before Angular destroys the directive/component.
     * Unsubscribe Observables and detach event handlers to avoid memory leaks.
     * @returns void
     */
    ngOnDestroy(): void {
        this.storeId = null;
    }
}
